<template>
  <div class="account-statement">
    <div class="relative">
      <SearchComponent
        :condition="condition"
        :routeName="$route.name"
        @updateData="_updateData"
        ref="search"
      >
        <template #default="{ condition, pickerOptions, searchData }">
          <div class="input-box">
            <span class="name">所属平台：</span>
            <div class="input">
              <el-select
                :disabled="$store.state.entryType === 'seller'"
                v-model="condition.platformId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                  v-for="item in filterDownData('platformList')"
                />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">订单归属商家：</span>
            <div class="input">
              <el-select
                :disabled="$store.state.entryType === 'seller'"
                v-model="condition.orderAttribution"
                placeholder="请选择"
                clearable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                  v-for="item in filterDownData('merchantList')"
                />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">所属小程序：</span>
            <div class="input">
              <el-select
                v-model="condition.appletsId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                  v-for="item in filterApplet"
                />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">对账单状态：</span>
            <div class="input">
              <el-select
                placeholder="请选择"
                clearable
                v-model="condition.status"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  :key="item.label"
                  v-for="item in filterDownData('billList')"
                />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">对账单时间：</span>
            <div class="input">
              <el-date-picker
                v-model="condition.time"
                type="month"
                placeholder="请选择时间"
                value-format="yyyy-MM"
                :picker-options="pickerOptions"
                clearable
              />
            </div>
          </div>
          <el-button
            size="60"
            @click="searchData"
            class="iconfont icon-sousuo"
            round
          />
        </template>
      </SearchComponent>

      <TableComponent
        @updateData="_updateData"
        :pagination="pagination"
        :routeName="$route.name"
      >
        <template #default="{ handleSelectionChange, openExportPop }">
          <div class="btn-all">
            <!--            <el-button-->
            <!--              size="98"-->
            <!--              class="d5"-->
            <!--              style="float:right"-->
            <!--              @click="openExportPop"-->
            <!--              v-permission:export="$route.meta.permission"-->
            <!--            >-->
            <!--              导出-->
            <!--            </el-button>-->
          </div>
          <el-table
            v-min-height
            :data="tableData"
            ref="table"
            :height="500"
            @selection-change="handleSelectionChange"
            header-cell-class-name="theader-th"
            cell-class-name="tbody-td"
          >
            <el-table-column
              fixed
              type="selection"
              align="center"
              width="130"
            />
            <el-table-column
              prop="merchantName"
              align="center"
              label="入驻商家"
              min-width="220"
            />
            <el-table-column
              prop="appletName"
              align="center"
              label="小程序名称"
              min-width="180"
            />
            <el-table-column
              label="账单总订单数量"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                <p class="ellipses">
                  <span class="category">跨境</span>
                  <span class="num">{{ scope.row.crossOrderNumber }}</span>
                </p>
                <p class="ellipses">
                  <span class="category black">完税</span>
                  <span class="num">{{ scope.row.taxOrderNumber }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column
              label="账单总SKU数量"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                <p class="ellipses">
                  <span class="category">跨境</span>
                  <span class="num">{{ scope.row.crossSkuNumber }}</span>
                </p>
                <p class="ellipses">
                  <span class="category black">完税</span>
                  <span class="num">{{ scope.row.taxSkuNumber }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="销售总金额" align="center" min-width="200">
              <template slot-scope="scope">
                <p class="ellipses">
                  <span class="category">跨境</span>
                  <span class="num">{{ scope.row.crossSalesAmount }}</span>
                </p>
                <p class="ellipses">
                  <span class="category black">完税</span>
                  <span class="num">{{ scope.row.taxSalesAmount }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="申报总金额" align="center" min-width="180">
              <template slot-scope="scope">
                <p class="ellipses">
                  <span class="category">跨境</span>
                  <span class="num">{{ scope.row.crossDeclareAmount }}</span>
                </p>
                <p class="ellipses">
                  <span class="category black">完税</span>
                  <span class="num">{{ scope.row.taxDeclareAmount }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column
              label="综合税总金额"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                <p class="ellipses">
                  <span class="category">跨境</span>
                  <span class="num">{{ scope.row.crossTariffAmount }}</span>
                </p>
                <p class="ellipses">
                  <span class="category black">完税</span>
                  <span class="num">{{ scope.row.taxTariffAmount }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="提价总金额" align="center" min-width="180">
              <template slot-scope="scope">
                <p class="ellipses">
                  <span class="category">跨境</span>
                  <span class="num">{{ scope.row.crossRaiseAmount }}</span>
                </p>
                <p class="ellipses">
                  <span class="category black">完税</span>
                  <span class="num">{{ scope.row.taxRaiseAmount }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column
              label="提价部分综合税"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                <p class="ellipses">
                  <span class="category">跨境</span>
                  <span class="num">{{
                    scope.row.crossRaiseTariffAmount
                  }}</span>
                </p>
                <p class="ellipses">
                  <span class="category black">完税</span>
                  <span class="num">{{ scope.row.taxRaiseTariffAmount }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="对账单状态" align="center" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.status | formatAccountmentType }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作日志"
              align="center"
              min-width="180"
              v-if="$route.meta.permission.includes('log')"
            >
              <template slot-scope="scope">
                {{ scope.row.operator }}
                <p class="log" @click="jumpRouteLog(scope.row)">查看日志</p>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              min-width="220"
              class-name="visible"
            >
              <template slot-scope="scope">
                <el-button
                  size="36"
                  round
                  v-permission:details="$route.meta.permission"
                  @click="jumpRoute(scope.row)"
                  class="iconfont icon-chakanxiangqing"
                />
                <el-button
                  size="36"
                  round
                  v-permission:details="$route.meta.permission"
                  @click="openSettingsAmount(scope.row)"
                  class="iconfont icon-shezhi"
                />
                <el-button
                  size="36"
                  round
                  v-permission:check="$route.meta.permission"
                  @click="accountStatementCheck(scope.row)"
                  class="iconfont icon-shenhe"
                />
                <el-button
                  size="36"
                  round
                  v-permission:settlement="$route.meta.permission"
                  @click="settlement(scope.row)"
                  class="iconfont icon-caiwu sub-color"
                />
              </template>
            </el-table-column>
          </el-table>
        </template>
      </TableComponent>

      <div class="mask foot-fixed" v-if="dialogFormVisible">
        <el-dialog
          :visible.sync="dialogFormVisible"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="true"
          custom-class="dialog"
          :modal="false"
          :center="true"
          width="50%"
        >
          <div slot="title" class="title">分润比例</div>
          <el-Scrollbar :native="false">
            <el-form :model="dialogForm" label-width="auto">
              <el-form-item label="入驻商家：">
                <div class="input-box">
                  <div class="input">
                    <el-input
                      v-model="dialogForm.merchantName"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="小程序名称：">
                <div class="input-box">
                  <div class="input">
                    <el-input
                      v-model="dialogForm.appletName"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="对账单时间：">
                <div class="input-box">
                  <div class="input">
                    <el-input
                      v-model="dialogForm.time"
                      placeholder="请输入"
                      clearable
                      disabled
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="平台备注：">
                <div class="input-box">
                  <div class="input" style="width: 26rem">
                    <el-input
                      v-model="dialogForm.platformRemarks"
                      placeholder="请输入"
                      clearable
                      :disabled="$store.state.entryType !== 'admin'"
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="商家备注：">
                <div class="input-box">
                  <div class="input" style="width: 26rem">
                    <el-input
                      v-model="dialogForm.merchantRemarks"
                      placeholder="请输入"
                      clearable
                      :disabled="$store.state.entryType === 'admin'"
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                label="销售总金额（完）："
                :class="index !== 0 && 'none'"
                v-for="(item, index) in dialogForm.taxRules"
                :key="index"
              >
                <div class="input-box">
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      v-model="item.startAmount"
                      type="number"
                      clearable
                      :disabled="$store.state.entryType !== 'admin'"
                    />
                  </div>
                  至
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      v-model="item.endAmount"
                      type="number"
                      clearable
                      :disabled="$store.state.entryType !== 'admin'"
                    />
                  </div>
                  <span class="name" style="margin-left: 2.8rem"
                    >分润比例：</span
                  >
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.commissionRatio"
                      clearable
                      :disabled="$store.state.entryType !== 'admin'"
                    />
                  </div>
                  %
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index === 0"
                    class="sub-color iconfont icon-tianjia"
                    round
                    size="36"
                    :disabled="$store.state.entryType !== 'admin'"
                    @click="addLine('taxRules')"
                  />
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index !== 0"
                    class="del-color iconfont icon-shanchu"
                    round
                    :disabled="$store.state.entryType !== 'admin'"
                    @click="delLine('taxRules', index)"
                    size="36"
                  />
                </div>
              </el-form-item>
              <el-form-item
                label="销售总金额（跨）："
                :class="index !== 0 && 'none'"
                v-for="(item, index) in dialogForm.crossRules"
                :key="-index - 1"
              >
                <div class="input-box">
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.startAmount"
                      clearable
                      :disabled="$store.state.entryType !== 'admin'"
                    />
                  </div>
                  至
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.endAmount"
                      clearable
                      :disabled="$store.state.entryType !== 'admin'"
                    />
                  </div>
                  <span class="name" style="margin-left: 2.8rem"
                    >分润比例：</span
                  >
                  <div class="input">
                    <el-input
                      placeholder="请输入"
                      type="number"
                      v-model="item.commissionRatio"
                      clearable
                      :disabled="$store.state.entryType !== 'admin'"
                    />
                  </div>
                  %
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index === 0"
                    class="sub-color iconfont icon-tianjia"
                    round
                    size="36"
                    :disabled="$store.state.entryType !== 'admin'"
                    @click="addLine('crossRules')"
                  />
                  <el-button
                    style="margin-left: 1rem"
                    v-if="index !== 0"
                    class="del-color iconfont icon-shanchu"
                    round
                    :disabled="$store.state.entryType !== 'admin'"
                    @click="delLine('crossRules', index)"
                    size="36"
                  />
                </div>
              </el-form-item>
            </el-form>
          </el-Scrollbar>
          <div slot="footer" class="dialog-footer">
            <el-button
              size="98"
              v-if="$store.state.entryType !== 'admin'"
              @click="changeAccountStatement(dialogForm, 3, 3)"
            >
              驳 回
            </el-button>
            <el-button
              class="sub-color"
              size="98"
              v-permission:save="$route.meta.permission"
              @click="saveSettingsAmount"
            >
              确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import TableComponent from '../Components/TableComponent'
import SearchComponent from '../Components/SearchComponent'
import filterDownData from 'mixins/filterDownData'
import updateData from 'mixins/updateData'

export default {
  name: 'accountStatement',
  mixins: [updateData, filterDownData],
  components: {
    TableComponent,
    SearchComponent,
  },
  data() {
    this.keyMap = {
      bill_list: {
        name: 'tableData',
        bill_id: 'id',
        reconciler: 'operator',
        bill_no: 'singleNumber',
        bill_name: 'statementName',
        bill_source: 'source',
        bill_status: 'status',
        statement_time: 'time',
        applet_id: 'appletId',
        app_name: 'appletName',
        merchant_id: 'merchantId',
        merchant_name: 'merchantName',
        duty_order_number: 'taxOrderNumber',
        cross_order_number: 'crossOrderNumber',
        duty_order_amount: 'taxSalesAmount',
        cross_order_amount: 'crossSalesAmount',
        duty_order_tariff: 'taxTariffAmount',
        cross_order_tariff: 'crossTariffAmount',
        duty_sku_number: 'taxSkuNumber',
        cross_sku_number: 'crossSkuNumber',
        duty_goods_price: 'taxDeclareAmount',
        cross_goods_price: 'crossDeclareAmount',
        duty_diff_price: 'taxRaiseAmount',
        cross_diff_price: 'crossRaiseAmount',
        duty_diff_tariff: 'taxRaiseTariffAmount',
        cross_diff_tariff: 'crossRaiseTariffAmount',
        merchant_remarks: 'merchantRemarks',
        platform_remarks: 'platformRemarks',
        cross_share_rules: 'crossRules',
        duty_share_rules: 'taxRules',
        sales_end_amount: 'endAmount',
        sales_start_amount: 'startAmount',
        commission_rate: 'commissionRatio',
        rule_id: 'ruleId',
        royalty_type: 'royaltyType',
      },
    }
    return {
      dialogFormVisible: false,
      dialogForm: {},
      condition: {
        orderAttribution: '',
        appletsId: '',
        platformId: '',
      },
      tableData: [],
      pagination: {},
    }
  },
  created() {
    this._getAccountStatementList({
      curpage: 1,
    })
  },
  computed: {
    filterApplet() {
      if (this.$store.state.entryType === 'seller') {
        this.condition.orderAttribution = this.$store.state.merchantId
        this.condition.platformId = this.$store.state.platformId
      }
      const applets = this.filterDownData('appletsList').filter((v) => {
        return v.merchantId === this.condition.orderAttribution
      })
      this.condition.appletsId = ''
      return applets
    },
  },
  methods: {
    /**
     * 获取对账单列表
     * @param params
     */
    _getAccountStatementList(params) {
      this.api.getAccountStatementList(params).then((res) => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 跳转对账单详情页
     * @param row
     */
    jumpRoute(row) {
      const { id, statementName, singleNumber } = row
      this.$router.push({
        name: 'accountStatementDetails',
        query: {
          id: id,
          title: statementName,
          num: singleNumber,
        },
      })
    },
    /**
     * 添加行
     * @param prop
     */
    addLine(prop) {
      const type = prop === 'taxRules' ? '1' : '2'
      const line = {
        ruleId: 0,
        startAmount: '',
        endAmount: '',
        commissionRatio: '',
        royaltyType: type,
      }
      this.dialogForm[prop].push(line)
    },
    /**
     * 删除行
     * @param prop
     * @param index
     */
    delLine(prop, index) {
      const row = this.dialogForm
      const id = row.id
      const ruleId = row[prop][index].ruleId
      if (id) {
        this.api
          .delAccountStatementItem({
            bill_id: id,
            rule_id: ruleId,
          })
          .then(() => {
            this.$notify({
              type: 'success',
              message: '删除成功~！😁',
            })
          })
      }
      row[prop].splice(index, 1)
    },
    /**
     * 跳转对账单日志列表页
     * @param row
     */
    jumpRouteLog(row) {
      const { id, statementName } = row
      this.$router.push({
        name: 'accountStatementLog',
        query: {
          id: id,
          title: statementName,
        },
      })
    },
    /**
     * 打开设置分润比例
     * @param row
     */
    openSettingsAmount(row) {
      this.dialogFormVisible = true
      const {
        id,
        merchantName,
        appletName,
        time,
        platformRemarks,
        merchantRemarks,
        crossRules,
        taxRules,
      } = row
      this.dialogForm = {
        id,
        merchantName,
        appletName,
        time,
        platformRemarks,
        merchantRemarks,
        crossRules:
          crossRules.length > 0
            ? crossRules
            : [
                {
                  ruleId: 0,
                  startAmount: '',
                  endAmount: '',
                  commissionRatio: '',
                  royaltyType: '2',
                },
              ],
        taxRules:
          taxRules.length > 0
            ? taxRules
            : [
                {
                  ruleId: 0,
                  startAmount: '',
                  endAmount: '',
                  commissionRatio: '',
                  royaltyType: '1',
                },
              ],
      }
    },
    /**
     * 保存分润比例
     */
    saveSettingsAmount() {
      if (this.$store.state.entryType === 'seller') {
        this.changeAccountStatement(this.dialogForm, 4)
      } else {
        const {
          crossRules,
          taxRules,
          platformRemarks,
          merchantRemarks,
          id,
          appletName,
        } = this.dialogForm
        const cloneCrossRules = this.utils._cloneDeep(crossRules)
        const cloneTaxRules = this.utils._cloneDeep(taxRules)
        const info = {
          id,
          appletName,
          platformRemarks,
          merchantRemarks,
          crossRules: cloneCrossRules,
          taxRules: cloneTaxRules,
        }
        const newMap = this.utils._reverseObj(this.keyMap)
        const data = {
          tableData: info,
        }
        this.utils._modifyObjKey(data, newMap)
        data.bill_list.operator = this.$store.state.userName
        data.bill_list.audit_status = 1
        this.api.saveAccountStatementInfo(data.bill_list).then((res) => {
          this.$notify({
            type: 'success',
            message: '保存成功~！',
          })
          this._getAccountStatementList({
            curpage: this.pagination.currentPage,
          })
        })
      }

      this.dialogFormVisible = false
    },
    /**
     * 更改对账单状态
     * @param op
     * @param billStatus
     * @param auditStatus
     */
    changeAccountStatement(op, billStatus, auditStatus) {
      this.api
        .changeAccountStatementStatus({
          bill_id: op.id,
          merchant_remarks: op.merchantRemarks,
          bill_status: billStatus,
          audit_status: auditStatus,
          app_name: op.appletName,
        })
        .then((res) => {
          this.$notify({
            type: 'success',
            message: res.message,
          })
          this._getAccountStatementList({
            curpage: this.pagination.currentPage,
          })
          this.dialogFormVisible = false
        })
    },
    /**
     * 结账
     * @param row
     */
    settlement(row) {
      this.$confirm('确定结账此对账单？', '提示', {
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true,
      }).then(() => {
        this.changeAccountStatement(row, 6)
      })
    },
    /**
     * 财务审核对账单
     * @param row
     */
    accountStatementCheck(row) {
      this.$confirm('确定通过账单审核？', '提示', {
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true,
      }).then(() => {
        this.changeAccountStatement(row, 5)
      })
    },
  },
}
</script>
<style lang="scss">
.account-statement {
  .mask {
    .title {
      font-size: 1.3rem;
    }

    &.foot-fixed {
      .el-dialog {
        overflow: hidden;
        height: 35rem;

        .el-form {
          padding-bottom: 5rem;
        }
      }

      .none {
        .el-form-item__label {
          opacity: 0;
        }
      }
    }
  }

  .log {
    cursor: pointer;
    text-decoration: underline;
  }

  .icon-shezhi,
  .icon-caiwu {
    &:after {
      content: '';
      position: absolute;
      bottom: -1rem;
      left: 1.5rem;
      padding: 0 0.7rem;
      height: 1.5rem;
      line-height: 1.5rem;
      background-color: #fff;
      box-shadow: 0 0.1rem 0.6rem 0 rgba(186, 186, 186, 0.75);
      border-radius: 0.3rem;
      font-size: 0.6rem;
      color: #797979;
      opacity: 0;
      overflow: hidden;
      transition: all 0.3s;
      z-index: 1;
    }

    &:hover {
      &:after {
        opacity: 1;
        overflow: visible;
      }
    }
  }

  .icon-shezhi {
    &:after {
      content: '设置参数';
    }
  }

  .icon-caiwu {
    &:after {
      left: -1.5rem;
      content: '结账';
    }
  }
}
</style>
